import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Box,
  TextField,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DeleteIcon from '@mui/icons-material/Delete';
import { GeneralInfoField, StatusCommissionField, AddressField, ContactField, SalesPersonStatus, SalesPersonAppliedTo } from './salesPersonFormDataConfig';
import API_BASE_URL from '../../../../Constants';
import { useAuth } from '../../../../contexts/AuthContext';


const ViewSalesPersonModal = ({ open, handleClose, salesPerson, setSalesPerson, setNext, setPrev, allPersons, updateAll }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFullView, setIsFullView] = useState(false);




  const { user } = useAuth();



  const [pendingRequest, setPendingRequest] = useState('');

  const [lockedModal, setLockedModal] = useState(false);
  const [lockOwner, setLockOwner] = useState('');
  const [eventSRC, setEventSRC] = useState(null);



  useEffect(() => {
    setIsEditMode(false);
  }, [open])

  useEffect(() => {
    const eventSource = new EventSource(`${API_BASE_URL}/sse/subscribe?username=${encodeURIComponent(user.username)}`);
    setEventSRC(eventSource);

    eventSource.onmessage = (event) => {
      alert(event.data);
    };

    eventSource.onerror = (err) => {
      console.error('EventSource failed:', err);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [user]);


  // componentUnmount useEffect
  useEffect(() => {
    return () => {
      if (eventSRC) {
        eventSRC.close();
      }
    };
  }, [eventSRC]);


  const clearUserLocks = async (user) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/record/${encodeURIComponent(user)}/clear-locks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.ok) {
        const message = await response.text(); // Get the response message
        console.log('Server response:', message); // Logs the response from the server
        // notify all users that the record has been unlocked by post request
        // notify all the requesters for that particular record they requested is open
        notifyRequesters(salesPerson.id);


      } else {
        throw new Error('Failed to clear locks');
      }
    } catch (error) {
      console.error('An error occurred:', error.message);
    }
  };



  // API CALL TO NOTIFY REQUESTERS
  const notifyRequesters = async (recordId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/notify/requesters?recordId=${encodeURIComponent(recordId + "-salesperson")}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',

      });

      if (response.ok) {
        const message = await response.text();
        console.log('Server response:', message);
      } else {
        throw new Error('Failed to notify requesters');
      }
    } catch (error) {
      console.error('An error occurred:', error.message);
    }
  }

  const notifyUser = async (lockOwner, requester, recordId) => {
    try {
      await fetch(
        `${API_BASE_URL}/api/notify/owner?lockOwner=${encodeURIComponent(lockOwner)}&requester=${encodeURIComponent(requester)}&recordId=${encodeURIComponent(recordId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      alert('Notification sent successfully');
      setPendingRequest(null);
      setLockedModal(false);
    } catch (error) {
      console.error('Failed to send notification:', error.message);
    }
  };

  const handleRequestAccess = () => {
    if (pendingRequest) {
      notifyUser(lockOwner, user.username, pendingRequest);

      const eventSource = new EventSource(`${API_BASE_URL}/sse/subscribe/record?recordId=${pendingRequest}&username=${user.username}`);
      eventSource.onmessage = ({ data }) => {
        alert('Record [ ' + data + ' ] lock has been cleared');
        setPendingRequest(null);
        setLockedModal(false);
        eventSource.close();
      };
    }
  };


  const handleEditModal = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/record/${salesPerson.id + '-salesperson'}/lock?user=${encodeURIComponent(user.username)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        }
      );

      if (response.ok) {
        const data = await response.text();
        console.log(data);
        toggleEditMode();
        // setIsEditOpen(true);
      } else if (response.status === 401) {
        const owner = await response.text();
        console.log('Record is locked by:', owner);
        setLockOwner(owner);
        setPendingRequest(salesPerson.id + '-salesperson');
        setLockedModal(true);
      } else {
        throw new Error('Failed to lock record');
      }
    } catch (error) {
      alert('An error occurred: ' + error.message);
    }
  };



  // Toggle functions
  const toggleEditMode = () => {
    setIsEditMode((prevMode) => !prevMode);
  };

  const toggleFullView = () => {
    setIsFullView((prev) => !prev);
  };



  const updatePerson = (person, isDelete = false) => {
    let all = [...allPersons]
    let index = all.findIndex((c) => String(c.id) === String(person.id));
    if (isDelete) {
      // delete index record
      all.splice(index, 1);
    } else {
      all[index] = person;
    }
    updateAll(all);
  }



  const handleSaveChanges = async () => {


    try {
      const response = await fetch(`${API_BASE_URL}/api/setup/salesperson/salespersons/${salesPerson.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',

        },
        credentials: 'include',
        body: JSON.stringify(salesPerson),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();

      updatePerson(data);
      clearUserLocks(user.username);
      setIsEditMode(false);
    } catch (error) {
      console.error('Fetch error: ', error);
    }
  };

  const handleDelete = async () => {
    try {

      await fetch(`${API_BASE_URL}/api/setup/salesperson/deleteSalesPerson/${salesPerson.id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      updatePerson(salesPerson, true);
      clearUserLocks(user.username);
      handleClose();

    } catch (error) {
      console.error('Fetch error: ', error);
    }

  }

  const renderFields = (fields, formData, editable = false) => {
    return fields.map((field) => {
      return (
        <div key={field.key} className="flex items-center py-0.5">
          <h3
            className="flex min-w-[calc(40%-2rem)] my-auto px-2 text-right font-semibold text-lg text-gray-600"
            style={{
              position: 'relative',
              borderBottom: '4px dotted #ccc',  // Changed to dotted border
              paddingBottom: '10px',            // Adds space between text and border
              marginRight: '16px'               // Adds space between label and input
            }}
          >
            {field.label}
          </h3>
          <div className="w-full">
            {editable ?


              (
                (field.key !== 'status' && field.key !== 'appliedTo' && field.key !== 'percent') ?
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled={field.key === 'id'}
                    name={field.key}
                    value={formData[field.key] || ''}
                    onChange={(e) =>
                      setSalesPerson({ ...salesPerson, [field.key]: e.target.value })
                    }
                    InputProps={{
                      style: {
                        backgroundColor: 'white',
                      },
                    }}
                  />
                  :
                  // select options 
                  (

                    <>

                      {field.key === 'status' && (
                        // select options dropdown
                        <select
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          value={formData[field.key]}
                          onChange={(e) => {

                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) });
                          }}
                        >
                          {
                            SalesPersonStatus.map((status) => (
                              <option key={status.value} value={status.value}>
                                {status.label}
                              </option>
                            )
                            )
                          }
                        </select>
                      )}
                      {field.key === 'appliedTo' && (

                        <select
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          value={formData[field.key]}
                          onChange={(e) => {
                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) });
                          }}>
                          {
                            SalesPersonAppliedTo.map((applied) => (
                              <option key={applied.value} value={applied.value}>
                                {applied.label}
                              </option>
                            )
                            )
                          }
                        </select>
                      )}

                      {field.key === 'percent' && (

                        // number input 0 to 100 with decimal
                        <input
                          type="number"
                          min="0"
                          max="100"
                          step="0.01"
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          value={formData[field.key]}
                          onChange={(e) => {

                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) });
                          }}
                        />
                      )}
                    </>
                  )
              ) : (
                <Box
                  sx={{
                    padding: '6px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                >
                  {formData[field.key] !== undefined && formData[field.key] !== null
                    ?
                    field.map ? field.map[formData[field.key]] : formData[field.key]
                    : 'N/A'}
                </Box>
              )
            }
          </div>
        </div>
      )
    });
  };
  
  if (!salesPerson) return null;

  // Main return
  return (
    <>
      {/* Previous and Next Buttons placed outside the modal */}
      {open && !isEditMode && (
        <IconButton
          onClick={setPrev}
          sx={{
            position: 'fixed',
            left: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: '#ffffff',
            border: '1px solid #ccc',
            zIndex: 1301, // Higher than the modal's z-index
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
          }}
          aria-label="Previous Customer"
        >
          <NavigateBeforeIcon />
        </IconButton>
      )}

      {open && !isEditMode && (
        <IconButton
          onClick={setNext}
          sx={{
            position: 'fixed',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: '#ffffff',
            border: '1px solid #ccc',
            zIndex: 1301,
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
          }}
          aria-label="Next Customer"
        >
          <NavigateNextIcon />
        </IconButton>
      )}
      <Dialog
        open={open}
        onClose={() => { handleClose(); clearUserLocks(user.username) }}
        maxWidth="xl"
        fullWidth={true}
        fullScreen={isFullView}
        PaperProps={{
          sx: {
            backgroundColor: 'white',
            boxShadow: 'none',
            margin: isFullView ? 2 : 'auto',
            width: isFullView ? 'calc(100% - 32px)' : '80%',
            height: isFullView ? 'calc(100% - 32px)' : '80%',
          },
        }}
      >
        <DialogContent
          dividers
          sx={{
            padding: 0,
            maxHeight: '90vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Sticky Top Section */}
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#f0f4f8',
              zIndex: 2,
              borderBottom: '1px solid #ccc',
              borderTop: '1px solid #ccc',
            }}
          >
            {/* First Row: Back Button and Maximize Button */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              paddingY={1}
              paddingX={2}
              sx={{
                backgroundColor: '#e0e0e0',
                borderBottom: '1px solid #ccc',
              }}
            >
              <IconButton
                onClick={() => { handleClose(); clearUserLocks(user.username) }}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Close Modal"
              >
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                onClick={toggleFullView}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Toggle Fullscreen"
              >
                {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Box>

            {/* Second Row: Title */}
            <Box
              paddingX={2}
              paddingY={1}
              sx={{
                backgroundColor: '#fafafa',
                borderBottom: '1px solid #ccc',
              }}
            >
              <Typography
                variant="h3"
                component="div"
                className="font-bold"
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: '#333',
                }}
              >
                {
                  salesPerson.firstName + " " + salesPerson.lastName ||
                  'Sales Person Details'}
              </Typography>
            </Box>

            {/* Third Row: Action Buttons */}
            <Box
              display="flex"
              alignItems="center"
              paddingX={2}
              paddingBottom={2}
              paddingTop={2}
            >
              {/* Action Buttons */}
              <Box>
                <Button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#E53E3E',
                    color: 'white',
                    marginRight: '0.5rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                  }}
                  startIcon={<DeleteIcon />}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#C53030';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#E53E3E';
                  }}
                >
                  Delete
                </Button>
                {/* <Button
                  onClick={() => { }}
                  style={{
                    backgroundColor: '#4299E1',
                    color: 'white',
                    marginRight: '0.5rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                  }}
                  startIcon={<AddIcon />}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#2B6CB0';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#4299E1';
                  }}
                >
                  Add
                </Button> */}

                {isEditMode ? (
                  <>
                    <Button
                      onClick={handleSaveChanges}
                      style={{
                        backgroundColor: '#ECC94B',
                        color: 'white',
                        marginRight: '0.5rem',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#D69E2E';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ECC94B';
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      onClick={toggleEditMode}
                      style={{
                        backgroundColor: '#A0AEC0',
                        color: 'black',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#718096';
                        e.currentTarget.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#A0AEC0';
                        e.currentTarget.style.color = 'black';
                      }}
                    >
                      View
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={handleEditModal}
                    style={{
                      backgroundColor: '#ECC94B',
                      color: 'white',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#D69E2E';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#ECC94B';
                    }}
                  >
                    Edit
                  </Button>
                )}
              </Box>
            </Box>
          </Box>

          {/* Scrollable Content */}
          <Box sx={{ padding: 2 }}>
            {salesPerson ? (
              <div className="space-y-5 p-2 rounded-2xl">
                {/* General Information Section */}
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="general-info-content"
                    id="general-info-header"
                    sx={{ padding: '0 16px' }}
                  >
                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      General Information
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '12px' }}>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        xs: '1fr',
                        sm: '1fr',
                        md: '1fr',
                        lg: 'repeat(2, 1fr)',
                      }}
                      gap={0.5}
                      className="p-1"
                    >
                      {renderFields(GeneralInfoField, salesPerson, isEditMode)}
                    </Box>
                  </AccordionDetails>
                </Accordion>


                {/* Status/Commission Section */}
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="general-info-content"
                    id="general-info-header"
                    sx={{ padding: '0 16px' }}
                  >
                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      Status & Commission
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '12px' }}>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        xs: '1fr',
                        sm: '1fr',
                        md: '1fr',
                        lg: 'repeat(2, 1fr)',
                      }}
                      gap={0.5}
                      className="p-1"
                    >
                      {renderFields(StatusCommissionField, salesPerson, isEditMode)}
                    </Box>
                  </AccordionDetails>
                </Accordion>

                {/* Address Section */}
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="general-info-content"
                    id="general-info-header"
                    sx={{ padding: '0 16px' }}
                  >
                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      Address
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '12px' }}>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        xs: '1fr',
                        sm: '1fr',
                        md: '1fr',
                        lg: 'repeat(2, 1fr)',
                      }}
                      gap={0.5}
                      className="p-1"
                    >
                      {renderFields(AddressField, salesPerson, isEditMode)}
                    </Box>
                  </AccordionDetails>

                </Accordion>

                {/* Contact Section */}
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="general-info-content"
                    id="general-info-header"
                    sx={{ padding: '0 16px' }}
                  >
                    <Typography
                      variant="h5"
                      className="font-bold"
                      sx={{
                        paddingBottom: '4px',
                        width: '100%',
                        borderBottom: '1px solid #ccc',
                      }}
                    >
                      Contact
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '12px' }}>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        xs: '1fr',
                        sm: '1fr',
                        md: '1fr',
                        lg: 'repeat(2, 1fr)',
                      }}
                      gap={0.5}
                      className="p-1"
                    >
                      {renderFields(ContactField, salesPerson, isEditMode)}
                    </Box>
                  </AccordionDetails>
                </Accordion>

              </div>
            ) : (
              <Typography>No Sales Person details available.</Typography>
            )}
          </Box>
          {lockedModal && (
            <div className="fixed inset-0 overflow-y-auto z-50">
              <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                  <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <span
                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                  aria-hidden="true"
                >
                  &#8203;
                </span>

                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                          Record Locked
                        </h3>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            The record is currently being edited by{' '}
                            {lockOwner || 'someone'}. Do you want to
                            request access?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={handleRequestAccess}
                    >
                      Request Access
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setLockedModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

ViewSalesPersonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  salesPerson: PropTypes.object,
  setSalesPerson: PropTypes.func.isRequired,
  setNext: PropTypes.func.isRequired,
  setPrev: PropTypes.func.isRequired,
  allPersons: PropTypes.array.isRequired,
  updateAll: PropTypes.func.isRequired,
};

export default ViewSalesPersonModal;
